module.exports = __webpack_public_path__ + "static/hollywood-zoom-e1078e95c164cf9690c864c379f01f17.jpg";